import { Modal, Button, Icon } from "antd";
import { Upload } from "@/components";
import { uploadUrl } from "@/service";
import React from "react";

const { confirm } = Modal;

// 确认是否要求匹配
export const confirmMatch = function ({
  type,
  onOk,
  onCancel,
  defaultFileList = [],
  UPLOAD_SERVER_HOST = "",
}) {
  const name = { result: "成果", demand: "需求" }[type];
  const contraryName = { result: "成果", demand: "需求" }[type];

  let files = [...defaultFileList];

  const onUploadFileFinish = (e) => {
    const newFiles = e.file.response.files.map(({ fileShowName, url }) => ({
      file_name: fileShowName,
      file_path: url,
    }));
    files = [...files, ...newFiles];
  };

  const onRemoveFile = (file) => {
    files.remove(file.uid - 1);
  };

  confirm({
    title: `您的${name}已发布成功！是否需要智能匹配服务？`,
    content: (
      <div>
        <p>
          如需要智能匹配，请上传详细的附件资料，以便天合专家对您的{name}
          进行数字画像，画像完成后将为您自动匹配符合{contraryName}！
        </p>
        <p>如果已上传完毕，请直接点击确定！</p>
        <p className="m-md-t"></p>
        <Upload
          style={{ minWidth: "160px" }}
          name="files"
          onFinish={onUploadFileFinish}
          action={uploadUrl}
          defaultFileList={files.map(({ file_name, file_path }, i) => ({
            name: file_name,
            url: `http://${UPLOAD_SERVER_HOST}${file_path}`,
            status: "done",
            uid: i + 1,
          }))}
          onRemove={onRemoveFile}
        >
          <Button>
            <Icon type="upload" /> 上传
          </Button>
        </Upload>
      </div>
    ),
    onOk() {
      onOk(files);
    },
    onCancel,
  });
};
